import { PersonaConfig } from '../types';

export const standardForecastPersona: PersonaConfig = {
  id: 'standard_forecast',
  name: 'Standard Forecast',
  icon: '⛅',
  description: 'Standard comprehensive weather and environmental overlays.',
  accentColor: '#38bdf8',
  timeline: {
    showSolarLunarTrack: true,
    showMoonPhaseBadges: true,
  },
  forecastPanel: {
    temperaturePlotMode: 'all',
    hideAstronomicalEvents: false,
    showMilkyWayArButton: false,
  },
  mapDefaults: {
    recommendedPrimaryLayer: 'hrtemp',
    enabledOverlays: ['precip_radar'],
  },
};
